import { Component, OnDestroy, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { country } from 'src/app/common/enums/language';
import { LanguageService } from 'src/app/common/services/language.service';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { DuesLockService } from 'src/app/common/services/dues-lock.service';
import { CurrencyService } from 'src/app/util/currency.service';
import {
  PAYMENT_OVERDUE_COPY,
  PAYMENT_OVERDUE_CTA_ROUTE,
} from 'src/app/payment-overdue/payment-overdue.constants';
import {
  QR_CODE_FOR_AI,
  QR_CODE_FOR_ID,
  LOCKED_IMG_LITE,
} from 'src/defaultImages.js';

@Component({
  selector: 'app-locked-lite',
  templateUrl: './locked-lite.component.html',
  styleUrls: ['./locked-lite.component.css'],
})
export class LockedLiteComponent implements OnInit, OnDestroy {
  isIndo: boolean = false;
  currency = '';
  pendingAmount: string | null = null;
  amountDueLabel = PAYMENT_OVERDUE_COPY.en_US.AMOUNT_DUE;
  images = {
    QR_CODE_FOR_AI: QR_CODE_FOR_AI,
    QR_CODE_FOR_ID: QR_CODE_FOR_ID,
    LOCKED_IMG_LITE: LOCKED_IMG_LITE,
  };

  private subscription = new Subscription();

  constructor(
    private _languageService: LanguageService,
    private _router: Router,
    private _duesLockService: DuesLockService,
    private _localStorage: LocalStorageService,
    private _currency: CurrencyService,
    @Optional() private _modalRef: NzModalRef
  ) {
    this.isIndo = this._languageService.getCountry() === country.id.country;
    const lang = localStorage.getItem('language') || 'en_US';
    this.amountDueLabel =
      (PAYMENT_OVERDUE_COPY[lang] || PAYMENT_OVERDUE_COPY.en_US).AMOUNT_DUE;
  }

  ngOnInit() {
    this.currency =
      this._currency.getCurrency() ||
      this._localStorage.get('restaurant_currency') ||
      '';
    this.subscription.add(
      this._duesLockService.isActive$.subscribe(() => this.applyPendingDue())
    );
    this.applyPendingDue();
    this.refreshPendingDue();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  payToUnlock(): void {
    const returnUrl = this._router.url;
    if (this._modalRef) {
      this._modalRef.close({ success: true });
    }
    this._router.navigate([PAYMENT_OVERDUE_CTA_ROUTE], {
      state: {
        from: 'locked-lite',
        returnUrl,
      },
    });
  }

  private applyPendingDue(): void {
    const amount = this._duesLockService.getLockInfo().pendingAmount;
    this.pendingAmount =
      amount != null && String(amount).trim() !== '' ? String(amount) : null;
  }

  private refreshPendingDue(): void {
    const restaurantId = this._localStorage.get('restaurant_id');
    if (!restaurantId) {
      return;
    }
    this._duesLockService.resolve(restaurantId).then(() => this.applyPendingDue());
  }
}
